import Blog from "./components/Blog.vue";
import Intro from "./screens/Intro.vue";
import Dashboard from "./screens/Dashboard.vue";
import LiveTradingRoomRecordingsPage from "./screens/LiveTradingRoomRecordings/LiveTradingRoomRecordingsPage.vue";
import PortfolioPage  from  "./screens/Portfolio/PortfolioPage.vue";
import PerformancePage  from  "./screens/Performance/PerformancePage.vue";
import UpcomingWebinarsPage from "./components/UpcomingWebinarsPage.vue";
import RecordedWebinarsPage from "./components/RecordedWebinarsPage.vue";
import axios from "axios";
import WaitIndicator from '@/components/Common/WaitIndicator.vue';
import { formatDateQuery } from "./utils/formatters";
import { isAsteriskToken } from "typescript";


function getIeVersion() 
{
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");

    if (msie > 0) // If Internet Explorer, return version number
    {
        return parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)));
    }
    else  // If another browser, return 0
    {
        return null
    }

}

function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
export default {
    name: "app",
    data() {
        return {
            recentPostsItems: [],
            archiveItems: [],

            blogPosts: [

            ],
            blogTotalRows: 100,
            blogCurrentPage: 1,
            blogShowingSearch: false,
            blogTabInd: 1,
            upcomingWebinarItems: [],
            recordedWebinarItems: null,

            upcomingTotalPages: 4,
            upcomingCurrentPage: 1,
            upcomingTabInd: 1,
            recordedTotalRows: 4,
            recordedCurrentPage: 1,
            recordedTabInd: 1,
            recordedShowingSearch: false,
            loading: false,
            loadingCategories: true,
            errorMsg: null,
            page: '',
            webinarCategories: [],
            blogCategories: [],

            portfolioLinks:null,
            currentPortfolio: {},
            portfolioItems: null,
            dayHistory: null,
            trialInfo: null,
            tabInfo: null,
            userInfo: null,
            SpaQuickMenu: !window.RazorQuickMenu
        };
    },
    components: {
        Blog,
        UpcomingWebinarsPage,
        RecordedWebinarsPage,
        Intro,
        Dashboard,
        LiveTradingRoomRecordingsPage,
        PortfolioPage,
        PerformancePage,
        WaitIndicator
    },
    
    computed: {
        upcomingWebinarCategories(){
            return this.webinarCategories.filter(o=>o.announceable===true)
        },
        hasAllowedBlogCategories() {
            return this.blogCategories.some(o => o.isAvailable)
        },
        hasAllowedWebinarCategories() {
            return this.webinarCategories.some(o => o.isAvailable)
        },
        showRoot() {
            return this.page == 'root' && this.portfolioLinks
        },
        showBlog() {
            return this.page == 'blog'
        },
        showUpcoming() {
            return this.page == 'upcoming'
        },
        showRecorded() {
            return this.page == 'recorded'
        },
        showPortfolio() {
            return this.page == 'portfolio'
        },
        showIntro() {
            return this.page == 'intro'
        },
        dark() {
            return this.showIntro;
        },
        showPerformance() {
            return this.page == 'trading-performance'
        },
        showLiveTradingRoomRecordings() {
            return this.page == 'live-trading-room-recordings'
        }
    },
    async mounted() {
        
        if (window.location.pathname=='/'&& (window.location.hash=='')) 
        {
            this.page = 'intro';
        }
        if (window.dontLoadPage)
        {
         return;
        } 

        this.trackPageVisit(window.location.pathname.slice(1));  
        this.loadingCategories = true;
        await this.loadCategories();
        this.loadingCategories = false;
        if (!window.authenticated) {
           this.page = 'intro'
        }
        if (window.blogCategory) {
            const bcats = this.blogCategories.find(c => c.slug.trim().toLowerCase() == window.blogCategory.trim().toLowerCase());
            this.loadCategoryBlogs(bcats, 1);
            this.loadArchive(new Date().getFullYear());
            delete window.blogCategory;
        } else 
        if (window.upcomingCategory) {
            const ucats = this.webinarCategories.filter(c => c.title.toLowerCase() == window.upcomingCategory.toLowerCase());
            this.loadCollectionUpcomingWithFallbackToNext(ucats, 0);
            delete window.upcomingCategory;
        } else 
        if (window.recordedCategory) {
            const rcats = this.webinarCategories.find(c => c.title.toLowerCase() == window.recordedCategory.toLowerCase());
            this.loadCollectionPastWebinars(rcats, 1);
            delete window.recordedCategory;
        } else 
        if (window.portfolio) {
            this.loadPortfolio(window.portfolio);
            //this.loadPortfolioHistory(window.portfolio);
        } else if ((window.location.pathname=='/') && (window.location.hash=='#') && (window.authenticated)){
            this.page= 'root'
        }
        

        if (window.location.pathname == '/trading-performance') {
            this.loadPerformance();
    }
            this.loadPageByHash();             

        // window.addEventListener('hashchange', (e) => {
        //     if (window.location.hash='#blog'){
                
        //     }
        // });

        

        if (window.location.hash == '#performance' || window.location.href.indexOf('#performance')>=0) {
            this.loadPerformance();
        }

        if (window.location.hash == '#live-trading-room-recordings' || window.location.href.indexOf('#live-trading-room-recordings')>=0) {
            this.page= 'live-trading-room-recordings'
        }
    },
    methods: {
        async trackPageVisit(location){
            await axios.post('/api/pagevisits/track?location=' + location);
        },
        updateColor(index) {

            const row =  this.portfolioItems[index];
            const lowError = 0.25 * row.predictionError * row.predictionLow;
            const highError = 0.25 * row.predictionError * row.predictionHigh;
            if (row.actualPricePerShare === 0) {
                row.color = '';
            } else if (row.actualPricePerShare <= row.predictionLow + lowError) {
                console.log("Boolish " + row.Symbol + ": " + row.actualPricePerShare.toFixed(2) + "$<=" + row.predictionLow.toFixed(2) + "+" + lowError.toFixed(2));
                row.color =  'row-low-corridor'; // boolish
            } else if (row.actualPricePerShare >= row.predictionHigh - highError) {
                console.log("Bearish " + row.Symbol + ": " + row.actualPricePerShare.toFixed(2) + "$>=" + row.predictionHigh.toFixed(2) + "-" + highError.toFixed(2));
                row.color = 'row-high-corridor'; // bearish
            } else {
                row.color = '';
            }
        },
        async updateUpLevelColor(index, symbol, level) {
            const row =  this.portfolioItems[index];           
            const calcLevel = symbol.maxBid / row.actualPricePerShare;
            console.log("Actual Price: " + row.actualPricePerShare + " Level:" + level);
            console.log("MaxDir4Years: " + symbol.maxDir4Years);
            console.log(symbol.maxOption + " Bid:" + symbol.maxBid + " -> " + calcLevel);
            if (calcLevel > level) {                         
                row.color =  'row-up-level';
                const portfolios = document.querySelectorAll('.portfolioGrid');
                portfolios.forEach(portfolio =>{
                    const tbodys = portfolio.querySelectorAll('tbody');
                    tbodys[index].classList.add("row-up-level"); 
                });
            }
        },
        updateDownLevelColor(index, symbol, level) {            
            const row =  this.portfolioItems[index];
            const calcLevel =  symbol.minBid / row.actualPricePerShare;
            console.log("Actual price: " + row.actualPricePerShare + " Level:" + level);
            console.log("MinDir4Years: " + symbol.minDir4Years);
            console.log(symbol.minOption + " Bid:" + symbol.minBid + " -> " + calcLevel);
            if (calcLevel > level) {
                row.color =  'row-down-level';
                const portfolios = document.querySelectorAll('.portfolioGrid');
                portfolios.forEach(portfolio =>{
                    const tbodys = portfolio.querySelectorAll('tbody');
                    tbodys[index].classList.add("row-down-level"); 
                });
            }
        },
        clearUpDownLevelColor() {
            const portfolios = document.querySelectorAll('.portfolioGrid');
            portfolios.forEach(portfolio =>{
                const tbodys = portfolio.querySelectorAll('tbody');
                tbodys.forEach(tbody =>{
                    tbody.classList.remove("row-down-level");
                    tbody.classList.remove("row-up-level");
                });
            });
        },
        showPage(page){
            this.page = page;  
        },
        loadPageByHash() {
            
            var hashPage = {
                '#intro': { page: 'intro' },
                '#dashboard': { page: window.authenticated ? 'root' : "intro" },                
                '#portfolio': {
                init: () => {
                    // this.loadPortfolio(this.portfolioLinks[0]);
                    // this.loadPortfolioHistory(this.portfolioLinks[0]);
                }
                },
                '#blog': {
                init: () => {                    
                    const bcats = this.blogCategories[0];
                    this.loadCategoryBlogs(bcats, 1);
                    
                }
                },
                '#upcoming': {
                init: () => {
                    const ucats = this.webinarCategories.filter(function(e){return e.announceable});
                    this.loadCollectionUpcomingWithFallbackToNext(ucats, 0);
                }
                },
                '#recorded': {
                init: () => {
                    const rcats = this.webinarCategories[0];
                    this.loadCollectionPastWebinars(rcats, 1);
                }
                },
                '#performance': {
                init: () => {
                    this.loadPerformance();
                }
                },
                '#live-trading-room-recordings': { page: 'live-trading-room-recordings' },
            };
            const r = hashPage[window.location.hash];
            if (r){
                if( r.init)
                    r.init();
                else
                    this.page = r.page;
            }
        },
        async CheckAccess(id){
            if (!id.isAvailable){
                if (getIeVersion()){
                    await sleep(500)
                    this.loadPageByHash();
                    
                } else {
                    console.trace("page redirect by frontend");
                    window.location = '/offers/'+id.offerSlug;
                    return false;
                }
                
            }
            return true;
        }, 
        async loadPortfolio(id){
            this.clearUpDownLevelColor();
            this.errorMsg = '';
           
            this.loading = true;
            if (!this.CheckAccess(id)) return;

            var url = '/api/portfolio/'+id.id+'/json';

            if(id.symbol) url = url+'?symbol='+id.symbol;

            const e = await axios.get(url);
            this.currentPortfolio = id;
            this.$set(this.currentPortfolio, 'loadingQuotes', true);
            if (e.data.responseCode == 50){
                this.errorMsg = "Can't load portfolio";
                this.page = 'root';
                this.loading= false;
                return;
            }
            this.portfolioItems = e.data.payload.items;
            this.trialInfo = e.data.payload.trialInfo;
            this.tabInfo = e.data.payload.tabInfo;
            this.userInfo = e.data.payload.userInfo;
            this.page = 'portfolio';
            this.loading = false;
            for (let i = 0; i < this.portfolioItems.length - 1; i++) {
                this.updateColor(i);
            }
        },
        async loadPerformance(){
            this.errorMsg = '';
            this.loading = true;
            const e = await axios.get('/api/performance');
            
            if (e.data.responseCode == 50){
                this.page = 'root';
                this.loading= false;
                return;
            }
            this.performance = e.data.payload;
            this.page = 'trading-performance';
            this.loading = false;
            
            
        },
        async refreshPortfolioRealtime(id){
            if (!this.CheckAccess(id)) return;
            const rsp = await axios.get('/api/portfolio/'+id.id+'/refresh');
            var quotes =  rsp.data.payload;
            this.portfolioItems.map(e=>{
                var quote = quotes.filter(q=>q.ID == e.ID).first();
                //e.
                console.log(JSON.stringify(quote));
            });
            this.errorMsg = '';
        },
        async portfolioRefresh(id){
            this.CheckAccess(id);
            this.loadPortfolio(id);
        },
        async loadPortfolioHistory(id, date){            
            this.errorMsg = '';
           
            this.loading = true;
            if (!this.CheckAccess(id)) return;
            const e = await axios.get('/api/portfolio/'+id.id+'/history/'+ formatDateQuery(date));
            this.currentPortfolio = id;
            this.$set(this.currentPortfolio, 'loadingQuotes', true);
            if (e.data.responseCode == 50){
                this.errorMsg = "Can't load portfolio ";
                this.page = 'root';
                this.loading= false;
                return;
            }
            this.dayHistory = e.data.payload;
            this.page = 'portfolio';
            this.loading = false;
        },
        async refreshPortfolioHistory(id){
            if (!this.CheckAccess(id)) return;
            const rsp = await axios.get('/api/portfolio/'+id.id+'/refresh');
            var quotes =  rsp.data.payload;
            this.portfolioItems.map(e=>{
                var quote = quotes.filter(q=>q.ID == e.ID).first();
                //e.
                console.log(JSON.stringify(quote));
            });
            this.errorMsg = '';
        },
        async portfolioHistoryRefresh(payload){
            this.CheckAccess(payload.portfolio);
            this.loadPortfolioHistory(payload.portfolio, payload.date);
        },
        async loadStockRangeData(id, mode, level) {
            this.clearUpDownLevelColor();
            const symbols = this.portfolioItems.map(e=>{
                return e.symbol;
            });
            let query = '/api/portfolio/' + id + '/GetStockRangeData/?symbols=' + symbols;
            const result = await axios.get(query);
            const levels = result.data.payload;            
            for (let i = 0; i < this.portfolioItems.length; i++) {
                const symbol = levels.find(e => e.symbol == this.portfolioItems[i].symbol);
                if(symbol) {
                    if(mode == 'up') {
                        this.updateUpLevelColor(i, symbol, level);
                    }
                    else {
                        this.updateDownLevelColor(i, symbol, level);
                    }
                }
            }
        },
        searchRecorded(o){
            
            this.loading = true;
            axios.post("/api/webinars/search", o, {
                withCredentials: true
            })
                .then(response => {
                    this.recordedWebinarItems = response.data.payload.items;
                    this.recordedShowingSearch = true;
                    this.recordedTotalRows = response.data.payload.totalNumOfAvailableItems;
                    this.recordedCurrentPage = o.SkipPages+1;
                    this.errorMsg = '';
                    return;
                })
                .catch(error => {
                    console.log(error);
                    throw error;
                }).finally(() => {
                this.loading = false;
            });
        },
        searchBlog(o){
            this.loading = true;

            return axios
                .post("/api/blog/search", o, {
                    withCredentials: true
                })
                .then(response => {
                    if (response.data.payload!=null && response.data.payload.items!==null) {
                        this.blogPosts = response.data.payload.items;
                        this.blogTotalRows = response.data.payload.totalNumOfAvailableItems;
                        this.blogCurrentPage = o.SkipPages +1;
                        this.blogShowingSearch = true;
                        this.errorMsg = '';
                    } else {
                        this.blogPosts = [];
                    }
                    return;
                })
                .catch(error => {
                    console.log(error);
                    throw error;
                }).finally(() => {
                    this.loading = false;
                });
        },
        loadArchive(year) {
            const monthNames = [
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December"
            ];
            const self = this;
            return axios
                .get("/api/blog/archive/" + year, { withCredentials: true })
                .then(response => {
                    let acc = response.data.reduce((acc, v) => {
                        const month = monthNames[new Date(v.published).getMonth()];
                        const e = acc.find(el => el.name == month);
                        if (e) {
                            e.children.push(v);
                        } else {
                            acc.push({ name: month, children: [v] });
                        }
                        //acc[month] ? acc[month].children.push(v) : acc[month] = ;
                        return acc;
                    }, []);

                    this.archiveItems = [{ name: year, children: acc }];
                })
                .catch(error => {
                    console.log(error);
                    throw error;
                });
        },
        loadCategories() {
            return axios
                .get("/api/categories/user_categories", { withCredentials: true })
                .then(response => {
                    this.blogCategories = response.data.payload.categories;
                    this.webinarCategories = response.data.payload.webinar_collections;
                    this.portfolioLinks = response.data.payload.portfolios;
                })
                .catch(error => {
                    console.log(error);
                    throw error;
                });
        },

        loadCategoryBlogs: function (category, page) {           
           if (this.archiveItems === undefined || this.archiveItems.length == 0) {            
                this.loadArchive(new Date().getFullYear());
           }
           
            this.errorMsg = "";
            if (this.showBlog && this.blogCategories.indexOf(category) == this.blogTabInd && this.blogCurrentPage == page
                && !this.blogShowingSearch) {
                return true;
            }
            this.loading = true;
            if (!this.CheckAccess(category)) return;
            this.blogShowingSearch = false;

            console.trace("loadCategoryBlogs", category, page);
            //this.loading = true;
            return axios
                .get("/api/blog/category/" + category.title + "/page/" + page, {
                    withCredentials: true
                })
                .then(response => {
                    if (response.data.responseCode == 50) {
                        this.blogPosts = [];
                        this.blogTotalRows = 0;
                        this.errorMsg = "Empty Category";
                        return;
                    }
                    if (response.data.responseCode === 100) {
                        window.location.href = '/Offers/Choose?catid='+category.id;
                        return;
                    }
                    if (response.data.responseCode != 0)
                        throw "status=" + response.data.responseCode;

                    if (response.data.payload.items.length == 0) {
                        this.errorMsg = "Empty Category";
                    } else {
                        this.errorMsg = '';
                    }
                    this.blogTotalRows = response.data.payload.totalNumOfAvailableItems;
                    this.blogCurrentPage = page;
                    this.blogTabInd = this.blogCategories.indexOf(category);
                    this.blogPosts = response.data.payload.items;
                    
                    this.page = 'blog';
                })
                .catch(error => {
                    console.log(error);
                    throw error;
                }).finally(() => {
                    this.loading = false;
                });
        },
        loadCollectionUpcomingWithFallbackToNext(ucats, i){
            const last = ucats.length - 1;
            if (i > last) return;

            this.loadCollectionUpcomingWebinars(ucats[i], 1, ()=>{
                this.loadCollectionUpcomingWithFallbackToNext(ucats, i + 1);
            });      
        },

        loadCollectionUpcomingWebinars: function (col, page, fallback) {
            
            this.errorMsg = "";
            if (this.upcomingCurrentPage == page && this.showUpcoming && this.webinarCategories.indexOf(col) == this.upcomingTabInd) {
                return false;
            }
            this.loading = true;
            if (!this.CheckAccess(col)) return;

            return axios
                .get("/api/webinars/upcoming/collections/" + col.id + "/" + page, {
                    withCredentials: true
                })
                .then(response => {

                    if (response.headers["content-type"]=="text/html; charset=utf-8"){
                        location = '/Identity/Account/Login';
                    }
                    if (response.data.responseCode == 50) {
                        this.upcomingWebinarItems = [];
                        this.upcomingTotalPages = 0;
                        fallback();
                        return;
                    }
                    if (response.data.responseCode === 100) {
                        console.log('respnse 100');
                        //window.location.href = '/Offers/Choose?catid='+col.id;
                        return;
                    }
                    if (response.data.responseCode != 0)
                        throw "status=" + response.data.responseCode;

                    if (response.data.payload.items.length == 0) {
                        fallback();
                    } else {
                        this.errorMsg = '';
                    }
                   
                    this.upcomingCurrentPage = page;
                    this.upcomingTabInd = this.webinarCategories.indexOf(col);
                    this.upcomingWebinarItems = response.data.payload.items;
                    this.upcomingTotalPages =
                        response.data.payload.totalNumOfAvailableItems;
                        
                        this.page = 'upcoming';

                })
                .catch(error => {
                    console.log(error);
                    throw error;
                }).finally(() => {
                    this.loading = false;
                });
        },
        loadCollectionPastWebinars: function (col, page) {
            this.loading = true;
            if (!this.CheckAccess(col)) return;
            this.errorMsg = "";
            this.recordedShowingSearch = false;
            console.trace(col , page, this.recordedCurrentPage, this.recordedTabInd );
            if (this.recordedCurrentPage == page && this.showRecorded &&
                this.webinarCategories.indexOf(col) == this.recordedTabInd &&
                !this.recordedShowingSearch
            ) {
                return false;
            }
            this.recordedShowingSearch = false;

            this.loading = true;
            return axios
                .get("/api/webinars/recorded/collections/" + col.id + "/" + page, {
                    withCredentials: true
                })
                .then(response => {
                    if (response.headers["content-type"]=="text/html; charset=utf-8"){
                        location = '/Identity/Account/Login';
                    }

                    if (response.data.responseCode == 50) {
                        this.errorMsg = "Empty Category";
                        this.recordedWebinarItems = [];
                        this.recordedTotalRows = 0;
                        return;
                    }
                    if (response.data.responseCode === 100) {
                        window.location.href = '/Offers/Choose?catid='+col.id;
                        return;
                    }
                    if (response.data.responseCode != 0)
                        throw "status=" + response.data.responseCode;

                    if (response.data.payload.items.length == 0) {
                        this.errorMsg = "Empty Category";
                    } else {
                        this.errorMsg = '';
                    }
                   
                    this.recordedCurrentPage = page;
                    this.recordedTabInd = this.webinarCategories.indexOf(col);
                    this.recordedWebinarItems = response.data.payload.items;
                    this.recordedTotalRows =
                        response.data.payload.totalNumOfAvailableItems;
                        this.page = 'recorded';
                })
                .catch(error => {
                    console.log(error);
                    throw error;
                }).finally(() => {
                    this.loading = false;
                });
        },
        updateLoader: function (status) {
            this.loading = status;
            if (status) {
                this.errorMsg = '';
            }
        },
        failError: function (error) {
            this.errorMsg = error;
        }
    }
};

